import { ReactNode } from 'react';
import Sidebar from '@/shared/components/Sidebar';
import TopBar from '@/shared/components/TopBar';
import Footer from '@/shared/components/Footer';
import { useUser } from '@/contexts/UserContext';
import { useUserRoles } from '@/shared/hooks/userRoles';
import heroMyndImage from '@/assets/Hero-Mynd.png';

interface ContainerLayoutProps {
  children: ReactNode;
  shouldShowSidebar: boolean;
  shouldAllowRegionChange: boolean;
  shouldAllowAccountChange: boolean;
}

const ContainerLayout = ({ children, shouldShowSidebar, shouldAllowRegionChange, shouldAllowAccountChange }: ContainerLayoutProps) => {
  const { isPlatformUser } = useUserRoles();
  const shouldShowSidebarInternal = isPlatformUser && shouldShowSidebar;

  return (
    <div className="relative h-screen overflow-hidden">
      {/* <img
        src={heroMyndImage}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      /> */}
      {/* <div className="absolute inset-0 bg-background/30 backdrop-blur-[2px] dark:bg-background/50" /> */}
      <div className="relative z-10 flex h-full flex-col pt-20">
        <TopBar shouldAllowRegionChange={shouldAllowRegionChange} shouldAllowAccountChange={shouldAllowAccountChange} />
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <div className="relative flex flex-1 flex-row">
            {shouldShowSidebarInternal && <Sidebar />}
            <main
              className={`flex flex-1 flex-col ${shouldShowSidebarInternal ? 'ml-80' : 'ml-0'}`}
            >
              {children}
            </main>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ContainerLayout;
